import { Observable } from 'rxjs';
import { GeneralRoutePaths, OrderRoutePath } from './core/enums/route-types.enum';
import { UserRole } from './core/enums/user-role.enum';
import { TreeService } from './core/tree/tree.service';
import { ROLE_REDIRECTOR_REDIRECTS } from './role-redirector/injection.tokens';
import { RedirectInterface } from './role-redirector/model';

export const redirects: RedirectInterface[] = [
  {
    roles: [UserRole.ROLE_DEALER, UserRole.ROLE_NARBUTAS_LT, UserRole.ROLE_ADMIN],
    redirect: function (treeService: TreeService) {
      return new Observable((observer) => {
        observer.next([GeneralRoutePaths.NEWS]);
        observer.complete();
      });
    },
    deps: [TreeService],
  },
  {
    roles: [UserRole.ROLE_PM],
    redirect: function () {
      return new Observable((observer) => {
        observer.next([OrderRoutePath.ROOT, OrderRoutePath.WAITING]);
        observer.complete();
      });
    },
  },
];

export const REDIRECTS_FACTORY = () => {
  return redirects;
};

export const REDIRECTS_FACTORY_PROVIDER = {
  provide: ROLE_REDIRECTOR_REDIRECTS,
  useFactory: REDIRECTS_FACTORY,
};
